// extracted by mini-css-extract-plugin
module.exports = {"cookieNotificationHolder":"CookieNotification_cookieNotificationHolder__LYoy2","linkWrapper":"CookieNotification_linkWrapper__-jXQE"};